import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tiles, TileNames } from './Tiles';
import { firstLetterAllWordsToUpper } from '../utils/util';
export var Products;
(function (Products) {
    Products["ALL"] = "All Services";
    Products["SITE_HERO"] = "SiteHero";
    Products["ENERGY_TRACKER"] = "EnergyTracker";
    //TODO: disabled for now, since there's no relevant tiles for these products
    // CARWASH_ASSURE = 'CarwashAssure',
    // DISPENSER_SENTRY = 'DispenserSentry',
    Products["AUTO_SCHEDULER"] = "AutoScheduler";
    Products["DEMAND_MANAGER"] = "DemandManager";
    Products["OTHER"] = "Other";
})(Products || (Products = {}));
// Typed to ensure that every Tile is represented, then transformed to desired
// array for us in app
const serviceMap = {
    [Tiles.HvacOutliersCard]: {
        name: firstLetterAllWordsToUpper(TileNames.HvacOutliers),
        product: [Products.OTHER],
        description: 'Understand the total energy consumption and distribution among key equipment groups',
        key: Tiles.HvacOutliersCard,
        icon: 'pie',
    },
    [Tiles.EnergyDistributionCard]: {
        name: firstLetterAllWordsToUpper(TileNames.EnergyDistributionCard),
        product: [Products.ENERGY_TRACKER],
        description: 'Understand the total energy consumption and distribution among key equipment groups',
        key: Tiles.EnergyDistributionCard,
        icon: 'pie',
    },
    [Tiles.PeriodComparisonCard]: {
        name: firstLetterAllWordsToUpper(TileNames.PeriodComparisonCard),
        product: [Products.ENERGY_TRACKER],
        description: 'Understand the current consumption trend',
        key: Tiles.PeriodComparisonCard,
        icon: 'vertical bar',
    },
    [Tiles.EnergyInsightsCard]: {
        name: firstLetterAllWordsToUpper(TileNames.EnergyInsightsCard),
        product: [Products.ENERGY_TRACKER],
        description: 'View the fluctuation in power demand over time',
        key: Tiles.EnergyInsightsCard,
        icon: 'line',
    },
    [Tiles.Top5ConsumptionCard]: {
        name: firstLetterAllWordsToUpper(TileNames.Top5ConsumptionCard),
        product: [Products.ENERGY_TRACKER],
        key: Tiles.Top5ConsumptionCard,
        description: 'Recognize the top 5 equipment types that consume the most energy',
        icon: 'horizontal bar',
    },
    [Tiles.EmissionsCard]: {
        name: TileNames.EmissionsCard,
        product: [Products.ENERGY_TRACKER],
        key: Tiles.EmissionsCard,
        // TODO: make this accept a span so can format co2
        // description:
        //   'Displays the total amount of CO2 emitted due to energy consumed',
        description: (_jsxs("span", { children: ["CO", _jsx("sub", { children: "2" }, void 0), " Emissions"] }, void 0)),
        icon: 'line',
    },
    [Tiles.MajorIssuesCard]: {
        name: firstLetterAllWordsToUpper(TileNames.MajorIssuesCard),
        product: [Products.OTHER],
        key: Tiles.MajorIssuesCard,
        description: 'View a breakdown of total notifications',
        icon: 'pie',
    },
    [Tiles.EquipmentIssuesCard]: {
        name: firstLetterAllWordsToUpper(TileNames.EquipmentIssuesCard),
        product: [Products.OTHER],
        description: 'Recognize the top 5 pieces of equipment with highest number of notifications',
        key: Tiles.EquipmentIssuesCard,
        icon: 'pie',
    },
    [Tiles.RecommendationsCard]: {
        name: firstLetterAllWordsToUpper(TileNames.RecommendationsCard),
        product: [Products.OTHER],
        description: 'A series of automated recommendations that can help improve operations',
        key: Tiles.RecommendationsCard,
        // todo: verify - missing icon in spreadsheet from harsh
        icon: 'list',
    },
    [Tiles.Top5EquipmentEnergyConsumptionCard]: {
        name: firstLetterAllWordsToUpper(TileNames.Top5EquipmentEnergyConsumptionCard),
        product: [Products.ENERGY_TRACKER],
        key: Tiles.Top5EquipmentEnergyConsumptionCard,
        description: 'Recognize the top 5 energy consuming equipment groups',
        icon: 'list',
    },
    [Tiles.TopConsumingSpacesCard]: {
        name: firstLetterAllWordsToUpper(TileNames.TopConsumingSpacesCard),
        product: [Products.ENERGY_TRACKER],
        key: Tiles.TopConsumingSpacesCard,
        description: 'Recognize the top 5 energy consuming spaces',
        icon: 'list',
    },
    [Tiles.AmbientConditionsCard]: {
        name: firstLetterAllWordsToUpper(TileNames.AmbientConditionsCard),
        product: [Products.SITE_HERO],
        key: Tiles.AmbientConditionsCard,
        description: 'View the current ambient conditions across all spaces',
        icon: 'list',
    },
    [Tiles.SitePeakDemandCard]: {
        name: firstLetterAllWordsToUpper(TileNames.SitePeakDemandCard),
        product: [Products.ENERGY_TRACKER],
        key: Tiles.SitePeakDemandCard,
        description: 'Understand peak demand for the month and the equipment that contribute to it',
        // todo: what is number/list supposed to mean? everything else just one
        icon: 'list',
    },
    [Tiles.ControlsOverviewCard]: {
        name: firstLetterAllWordsToUpper(TileNames.ControlsOverviewCard),
        product: [Products.AUTO_SCHEDULER, Products.DEMAND_MANAGER],
        description: 'Overview of all equipment under Control',
        key: Tiles.ControlsOverviewCard,
        icon: 'pie',
    },
    [Tiles.ControlsSavingsCard]: {
        name: firstLetterAllWordsToUpper(TileNames.ControlsSavingsCard),
        product: [Products.AUTO_SCHEDULER, Products.DEMAND_MANAGER],
        description: 'View daily savings of equipment under Control',
        key: Tiles.ControlsSavingsCard,
        icon: 'bar',
    },
    [Tiles.EquipmentTemperatureComplianceCard]: {
        name: `${firstLetterAllWordsToUpper(TileNames.EquipmentTemperatureComplianceCard)}`,
        product: [Products.SITE_HERO],
        description: 'Provides high-level overview of compliance trends in your temperature sensitive equipment',
        key: Tiles.EquipmentTemperatureComplianceCard,
        icon: 'compliance',
    },
    [Tiles.AmbientConditionsTemperatureCard]: {
        name: firstLetterAllWordsToUpper(TileNames.AmbientConditionsTemperatureCard),
        product: [Products.SITE_HERO],
        description: 'View ambient temperature across different spaces in your facility',
        key: Tiles.AmbientConditionsTemperatureCard,
        icon: 'line',
    },
    [Tiles.AmbientConditionsHumidityCard]: {
        name: firstLetterAllWordsToUpper(TileNames.AmbientConditionsHumidityCard),
        product: [Products.SITE_HERO],
        description: 'View ambient humidity across different spaces in your facility',
        key: Tiles.AmbientConditionsHumidityCard,
        icon: 'line',
    },
    [Tiles.TemperatureReviewCard]: {
        name: firstLetterAllWordsToUpper(TileNames.TemperatureReviewCard),
        product: [Products.OTHER],
        description: 'View recent equipment temperature readings and compliance rates',
        key: Tiles.TemperatureReviewCard,
        icon: 'list',
    },
    [Tiles.DailyEnergyConsumptionCard]: {
        name: firstLetterAllWordsToUpper(TileNames.DailyEnergyConsumptionCard),
        product: [Products.ENERGY_TRACKER],
        description: 'View daily energy usage, comparing with operating vs non-operating hours',
        key: Tiles.DailyEnergyConsumptionCard,
        icon: 'vertical bar',
    },
    [Tiles.SetpointRecommendationCard]: {
        name: firstLetterAllWordsToUpper(TileNames.SetpointRecommendationCard),
        product: [Products.SITE_HERO],
        description: 'Provides recommended thermostat setpoints for the coming week that is optimizes for Customer Comfort.',
        key: Tiles.SetpointRecommendationCard,
        icon: 'list',
    },
    [Tiles.NonOperatingHourEfficiencyCard]: {
        name: firstLetterAllWordsToUpper(TileNames.NonOperatingHourEfficiencyCard),
        product: [Products.ENERGY_TRACKER],
        description: 'View energy usage of operating hours vs. non operating hours.',
        key: Tiles.NonOperatingHourEfficiencyCard,
        icon: 'pie',
    },
    // This is included here to keep consistent typing with Tiles in
    // SitePageInsights but then filtered before being returned
    [Tiles.AddTileCard]: {
        name: '',
        product: [Products.ENERGY_TRACKER],
        key: Tiles.AddTileCard,
        description: '',
        icon: 'list',
    },
};
export const SERVICES = Object.values(serviceMap).filter(({ name }) => name !== '');
export const ProductLabels = {
    [Products.AUTO_SCHEDULER]: (_jsxs("div", { children: [_jsx("b", { children: "Auto" }, void 0), "Scheduler"] }, void 0)),
    //TODO: disabled for now, since there's no relevant tiles for these products
    // [Products.CARWASH_ASSURE]: (
    //   <div>
    //     <b>CarWash</b>Assure
    //   </div>
    // ),
    // [Products.DISPENSER_SENTRY]: (
    //   <div>
    //     <b>Dispenser</b>Sentry
    //   </div>
    // ),
    [Products.ENERGY_TRACKER]: (_jsxs("div", { children: [_jsx("b", { children: "Energy" }, void 0), "Tracker"] }, void 0)),
    [Products.SITE_HERO]: (_jsxs("div", { children: [_jsx("b", { children: "Site" }, void 0), "Hero"] }, void 0)),
    [Products.DEMAND_MANAGER]: (_jsxs("div", { children: [_jsx("b", { children: "Demand" }, void 0), "Manager"] }, void 0)),
};
